import React from "react";

export const savedDocumentPageLabel = (index) => {
  if (index === 0) return "Front / First Page";
  if (index === 1) return "Back / Second Page";
  return `Extra Page ${index + 1}`;
};

export const savedDocumentIsImage = (page = {}) =>
  /\.(jpg|jpeg|png|webp|gif|heic|heif)(\?|$)/i.test(String(page?.signedUrl || ""));

export const savedDocumentPagesFor = (urls = [], documentTitle = "Document") =>
  urls.map((url, index) => ({
    signedUrl: url,
    name: savedDocumentPageLabel(index),
    caption: documentTitle,
  }));

export function ProfileSavedDocuments({
  pages = [],
  title = "Uploaded Pages",
  emptyText = "No uploaded pages found.",
  onPreview,
  previewTitle = "Document",
}) {
  return (
    <div className="care-profile-saved-documents">
      <div className="care-profile-saved-documents__head">
        <strong>{title}</strong>
        <small>{pages.length ? `${pages.length} page${pages.length === 1 ? "" : "s"}` : emptyText}</small>
      </div>
      {pages.length ? (
        <div className="care-profile-saved-document-grid">
          {pages.map((page, index) => (
            <button
              className="care-profile-saved-document-page"
              type="button"
              key={page.fileId || page.signedUrl || `${previewTitle}-${index}`}
              onClick={() => onPreview?.(page, index, previewTitle, pages)}
            >
              <span className="care-profile-saved-document-page__thumb">
                {page.signedUrl && savedDocumentIsImage(page) ? (
                  <img
                    src={page.signedUrl}
                    alt=""
                    onError={(event) => {
                      event.currentTarget.style.display = "none";
                    }}
                  />
                ) : (
                  <i className="ti ti-file-description" aria-hidden="true" />
                )}
              </span>
              <span className="care-profile-saved-document-page__caption">
                <strong>{page.name || savedDocumentPageLabel(index)}</strong>
                <small>{page.caption || page.fileName || page.name || savedDocumentPageLabel(index)}</small>
              </span>
              <i className="ti ti-eye" aria-hidden="true" />
            </button>
          ))}
        </div>
      ) : (
        <div className="care-profile-work-auth-pages__empty">
          <i className="ti ti-file-off" />
          <span>{emptyText}</span>
        </div>
      )}
    </div>
  );
}

export function ProfileDocumentDetails({ title = "Details", subtitle = "Profile record", rows = [] }) {
  return (
    <div className="care-profile-work-auth-details">
      <div className="care-profile-work-auth-details__head">
        <strong>{title}</strong>
        <small>{subtitle}</small>
      </div>
      <dl className="care-profile-work-auth-detail-grid">
        {rows.map(([label, value]) => (
          <div key={label}>
            <dt>{label}</dt>
            <dd>{value || "N/A"}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}

export function ProfileDocumentSection({
  detailsTitle,
  detailsSubtitle = "Profile record",
  rows = [],
  pages = [],
  documentTitle,
  documentPreviewTitle,
  onPreview,
}) {
  return (
    <div className="care-profile-work-auth-layout">
      <ProfileDocumentDetails title={detailsTitle} subtitle={detailsSubtitle} rows={rows} />
      <ProfileSavedDocuments
        pages={pages}
        previewTitle={documentPreviewTitle || detailsTitle || "Document"}
        onPreview={onPreview}
        emptyText="No uploaded pages found."
        title={documentTitle || "Uploaded Pages"}
      />
    </div>
  );
}
